<div class="e-mobility-box" [formGroup]="form">
  <div class="grid-x">
    <div class="cell medium-8">
      <h3 id="has_electric_car" [innerHTML]="textKeyPrefix + '.headline' | translate"></h3>
    </div>
    <div class="cell medium-4 radio-buttons">
      <div class="formfield radio">
        <mat-radio-group formControlName="has_electric_car">
          <mat-radio-button aria-describedby="has_electric_car" [attr.aria-expanded]="form?.controls['has_electric_car']?.value === true" aria-controls="e-form" color="primary" [value]="true">
            <span [innerHTML]="textKeyPrefix + '.ja' + '.label' | translate"></span>
          </mat-radio-button>
          <mat-radio-button aria-describedby="has_electric_car" color="primary" [attr.aria-expanded]="form?.controls['has_electric_car']?.value === true" aria-controls="e-form" [value]="false">
            <span [innerHTML]="textKeyPrefix + '.nein' + '.label' | translate"></span>
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </div>

  @if (form?.controls['has_electric_car']?.value === true) {
    <div id="e-form" class="e-mobility-form">
      <div class="e-mobility-wrapper">
        <label for="car_electricity" [innerHTML]="textKeyPrefix + '.subheadline' | translate"></label>
        @if (formError) {
          <div role="alert" class="form-errors" [innerHTML]="'stromcheck.stromkostenabrechnung.error.' + formError | translate: formErrorPlaceholder"></div>
        }
        <mat-checkbox disableRipple="all" formControlName="car_electricity_unknown" color="primary" [attr.aria-expanded]="form?.controls['car_electricity_unknown']?.value !== true" aria-controls="input-electricity info">{{textKeyPrefix + '.consumption' | translate}}</mat-checkbox>
        <div id="input-electricity" class="input-wrapper">
          @if (form?.controls['car_electricity_unknown']?.value !== true) {
            <div class="input-group">
              <input id="car_electricity" (keydown.enter)="saveCarElectricity(true)" class="input-group-field" formControlName="car_electricity" type="number" [placeholder]="'unit.kwh' | translate">
            </div>
          }
          @if (form?.controls['car_electricity_unknown']?.value !== true) {
            <button class="button" [attr.aria-expanded]="!!anfrage.userInput.ladestrom_elektrofahrzeug_verbrauch" aria-controls="info" (click)="saveCarElectricity(true)" [innerHTML]="textKeyPrefix + '.button.save' | translate"></button>
          }
        </div>
      </div>
      @if (form?.controls['car_electricity_unknown']?.value === true || hasCarElectricity) {
        <div id="info" class="e-mobility-ladestrom">
          <p class="info-box" [innerHTML]="(form?.controls['car_electricity_unknown']?.value ? textKeyPrefix + '.ladestrom.nein' : textKeyPrefix + '.ladestrom.ja') | translate: placeholder"></p>
        </div>
      }
    </div>
  }
</div>
